// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"699b9ff1","158":"f8d9a5e0","458":"fdbdfe4d","723":"cd62abe8"}[chunkId] + ".chunk.js";
};